import React, { useState, useEffect } from "react";
import { AIRTABLE_APIKEY, AIRTABLE_BASE } from "./config";
import { data } from "./components/data";
import { Preloader, Preloader0 } from "./uikit/Uikit";
import { getDataById } from "./components/utils";

const Airtable = require("airtable");

Airtable.configure({
  endpointUrl: "https://api.airtable.com",
  apiKey: AIRTABLE_APIKEY,
});
const base = Airtable.base(AIRTABLE_BASE);

const Context = React.createContext();

function Provider({ children }) {
  // const [items, setItems] = useState([]);
  // const [items, setItems] = useState(itemsCached);

  const [categories, setCategories] = useState([]);
  const [apps, setApps] = useState([]);

  // const [activeProjects, setActiveProjects] = useState([...data.projects.map(onePr => onePr['id'])]);
  // const [activeProjects, setActiveProjects] = useState(['gs', 'rc', 'ustoy']);
  const [activeUsers, setActiveUsers] = useState(["danny", "misha", "joe"]);
  const [activeProjects, setActiveProjects] = useState(["gs"]);
  const [activeDate, setActiveDate] = useState("10/27/2021");
  const [activeApps, setActiveApps] = useState([]);

  const getLocal = () => {
    let user = localStorage.getItem("user");
    return user
      ? JSON.parse(user)
      : {
          id: "",
          email: "",
          name: "",
          title: "",
          img: "",
        };
  };

  const defaultUser = "recMJRYVP47ZOqcj3";

  const [user, setUser] = useState({
    id: "",
    email: "",
    img: "",
    title: "",
    name: "",
    img: "",
  });


  const toggleProd = {
    playlistIcon: true,
    playlistAuthor: true,
  }
  const toggleDev = {
    playlistFilters: true,
    playlistImage: true,
    playlistIcon: true,
    playlistAuthor: true,
  }



  const [ready, setReady] = useState(false);


  const [version, setVersion] = useState(false); //dev=true//prod=false
  const [toggle, setToggle] = useState(version === false ? toggleProd : toggleDev); //dev//prod

  useEffect(() => {
    !version ? setToggle(toggleProd) : setToggle(toggleDev)
  }, [version])




  const getPlaylistIdFromName = (playlistName) => {
    let id = playlists.filter((p) => p["uniq"] === playlistName);
    // console.log('id[0][id] = ', id[0]['id']);
    return id.length ? id[0]["id"] : "";
  };

  const saveLocal = (user) => {
    localStorage.setItem("user", JSON.stringify(user));
  };

  const setUserEmail = (email) => {
    console.log("email = ", email);
    let userNew = JSON.parse(JSON.stringify(user));
    userNew = {
      ...user,
      email: email,
    };
    setUser(userNew);
    saveLocal(userNew);
  };

  const [users, setUsers] = useState([]);
  const [projects, setProjects] = useState([]);
  const [metadata, setMetadata] = useState([]);
  const [videos, setVideos] = useState([]);
  const [metaDataTypes, setMetaDataTypes] = useState([]);
  const [playlists, setPlaylists] = useState([]);
  const [spaces, setSpaces] = useState([]);

  useEffect(() => {
    if (!users.length) {
      base("Users")
        .select({
          maxRecords: 100,
          // sort: [{ field: "importance", direction: "desc" }],
        })
        .eachPage(
          function page(partialRecords, fetchNextPage) {
            setUsers([
              ...users,
              ...partialRecords
                .filter((record) => record.get("active"))
                .map((record) => ({
                  id: record["id"],
                  uniq: record.get("uniq"),
                  active: record.get("active"),
                  name: record.get("name"),
                  nameLast: record.get("nameLast"),
                  email: record.get("email"),
                  img: record.get("img") ? record.get("img")[0] : {},
                  title: record.get("title"),
                  metadata: record.get("metadata")
                    ? record.get("metadata")
                    : [],
                  videos: record.get("videos") ? record.get("videos") : [],
                })),
            ]);
            // partialRecords.forEach(function(record) {
            //   console.log('Retrieved', partialRecords.get('img_url'));
            // });
            fetchNextPage();
          },
          function done(err) {
            if (err) {
              console.error(err);
              return;
            } else {
            }
          }
        );
    }

    if (users.length && !user["id"]) {
      setUser({
        ...getUserDataById(defaultUser),
      });
    }
  }, [users]);

  useEffect(() => {
    if (!projects.length) {
      base("Projects")
        .select({
          maxRecords: 100,
          // sort: [{ field: "importance", direction: "desc" }],
        })
        .eachPage(
          function page(partialRecords, fetchNextPage) {
            setProjects([
              ...projects,
              ...partialRecords
                .filter((record) => record.get("active"))
                .map((record) => ({
                  id: record["id"],
                  uniq: record.get("uniq"),
                  title: record.get("title"),
                  img: record.get("img") ? record.get("img")[0] : {},
                  color: record.get("color"),
                  videos: record.get("videos") ? record.get("videos") : [],
                  users: record.get("users") ? record.get("users") : [],
                })),
            ]);
            // partialRecords.forEach(function(record) {
            //   console.log('Retrieved', partialRecords.get('img_url'));
            // });
            fetchNextPage();
          },
          function done(err) {
            if (err) {
              console.error(err);
              return;
            }
          }
        );
    }
  }, [projects]);

  useEffect(() => {
    if (!playlists.length) {
      base("Playlists")
        .select({
          maxRecords: 100,
          // sort: [{ field: "importance", direction: "desc" }],
        })
        .eachPage(
          function page(partialRecords, fetchNextPage) {
            setPlaylists([
              ...playlists,
              ...partialRecords
                .filter((record) => record.get("active"))
                .map((record) => ({
                  id: record["id"],
                  uniq: record.get("uniq"),
                  public: record.get("public"),
                  default: record.get("default"),
                  type: record.get("type"),
                  title: record.get("title"),
                  emoji: record.get("emoji"),
                  icon: record.get("icon"),
                  img: record.get("img") ? record.get("img")[0] : {},
                  color: record.get("color"),
                  videos: record.get("videos") ? record.get("videos") : [],
                  space: record.get("space") ? record.get("space")[0] : {},
                  user: record.get("user") ? record.get("user")[0] : {},
                })),
            ]);
            // partialRecords.forEach(function(record) {
            //   console.log('Retrieved', partialRecords.get('img_url'));
            // });
            fetchNextPage();
          },
          function done(err) {
            if (err) {
              console.error(err);
              return;
            }
          }
        );
    }
  }, [playlists]);

  useEffect(() => {
    if (!videos.length) {
      base("Videos")
        .select({
          maxRecords: 100,
          sort: [{ field: "date", direction: "desc" }],
        })
        .eachPage(
          function page(partialRecords, fetchNextPage) {
            setVideos([
              ...videos,
              ...partialRecords
                .filter((record) => record.get("active"))
                .map((record) => ({
                  id: record["id"],
                  uniq: record.get("uniq"),
                  url: record.get("url"),
                  mp4: record.get("mp4"),
                  img: record.get("img") ? record.get("img")[0] : {},
                  app: record.get("app") ? record.get("app")[0] : {},
                  date: record.get("date"),
                  length: record.get("length"),
                  title: record.get("title"),
                  sprite: record.get("sprite"),
                  user: record.get("user") ? record.get("user")[0] : {},
                  userImg: record.get("userImg")
                    ? record.get("userImg")[0]
                    : [],
                  metadata: record.get("metadata")
                    ? record.get("metadata")
                    : [],
                  playlists: record.get("playlists")
                    ? record.get("playlists")
                    : [],
                })),
            ]);
            // partialRecords.forEach(function(record) {
            //   console.log('Retrieved', partialRecords.get('img_url'));
            // });
            fetchNextPage();
          },
          function done(err) {
            if (err) {
              console.error(err);
              return;
            }
          }
        );
    }
  }, [videos]);

  useEffect(() => {
    if (!apps.length) {
      base("Apps")
        .select({
          maxRecords: 100,
          // sort: [{ field: "importance", direction: "desc" }],
        })
        .eachPage(
          function page(partialRecords, fetchNextPage) {
            setApps([
              ...apps,
              ...partialRecords
                .filter((record) => record.get("active"))
                .map((record) => ({
                  id: record["id"],
                  name: record.get("name"),
                  img: record.get("img") ? record.get("img")[0] : {},
                  title: record.get("title"),
                })),
            ]);
            // partialRecords.forEach(function(record) {
            //   console.log('Retrieved', partialRecords.get('img_url'));
            // });
            fetchNextPage();
          },
          function done(err) {
            if (err) {
              console.error(err);
              return;
            }
          }
        );
    }
  }, [apps]);

  useEffect(() => {
    if (!metadata.length && metaDataTypes.length) {
      base("Metadata")
        .select({
          maxRecords: 100,
          view: "DONTCHANGE",
          // sort: [{ field: "importance", direction: "desc" }],
        })
        .eachPage(
          function page(partialRecords, fetchNextPage) {
            setMetadata([
              ...metadata,
              ...partialRecords
                .filter((record) => record.get("active"))
                .map((record) => ({
                  id: record["id"],
                  uniq: record.get("uniq"),
                  author: record.get("author"),
                  metaTime: record.get("metaTime"),
                  shownByDefault: record.get("shownByDefault"),

                  type: record.get("type") ? record.get("type")[0] : {},
                  typeRef: record.get("typeRef")
                    ? record.get("typeRef")[0]
                    : {},
                  typeIcon: record.get("typeIcon")
                    ? record.get("typeIcon")[0]
                    : {},
                  typeColor: record.get("typeColor")
                    ? record.get("typeColor")[0]
                    : {},
                  typeTitle: record.get("typeTitle")
                    ? record.get("typeTitle")[0]
                    : {},

                  authorImg: record.get("authorImg")
                    ? record.get("authorImg")[0]
                    : {},
                  authorName: record.get("authorName"),
                  commentText: record.get("commentText"),
                  commentParentId: record.get("commentParentId"),
                  commentParentText: record.get("commentParentText"),
                  videoId: record.get("videoId")
                    ? record.get("videoId")[0]
                    : "",
                  videoThumb: record.get("videoThumb")
                    ? record.get("videoThumb")[0]
                    : {},
                })),
            ]);
            // partialRecords.forEach(function(record) {
            //   console.log('Retrieved', partialRecords.get('img_url'));
            // });
            fetchNextPage();
          },
          function done(err) {
            if (err) {
              console.error(err);
              return;
            }
          }
        );
    }
  }, [metadata, metaDataTypes]);

  useEffect(() => {
    if (!metaDataTypes.length) {
      base("MetadataTypes")
        .select({
          maxRecords: 100,
          view: "Grid view",
          // view: "DONTCHANGE",
          sort: [{ field: "importance", direction: "desc" }],
        })
        .eachPage(
          function page(partialRecords, fetchNextPage) {
            setMetaDataTypes([
              ...metaDataTypes,
              ...partialRecords
                .filter((record) => record.get("active"))
                .map((record) => ({
                  id: record["id"],
                  type: record.get("type"),
                  title: record.get("title"),
                  icon: record.get("icon"),
                  color: record.get("color"),
                  emoji: record.get("emoji"),
                })),
            ]);
            fetchNextPage();
          },
          function done(err) {
            if (err) {
              console.error(err);
              return;
            }
          }
        );
    }
  }, [metaDataTypes]);



  useEffect(() => {
    if (!spaces.length) {
      base("Spaces")
        .select({
          maxRecords: 100,
          // view: "Grid view",
          // view: "DONTCHANGE",
          sort: [{ field: "importance", direction: "asc" }],
        })
        .eachPage(
          function page(partialRecords, fetchNextPage) {
            setSpaces([
              ...metaDataTypes,
              ...partialRecords
                .filter((record) => record.get("active"))
                .map((record) => ({
                  id: record["id"],
                  uniq: record.get("uniq"),
                  title: record.get("title"),
                  icon: record.get("icon"),
                  titleShort: record.get("titleShort"),
                  img: record.get("img") ? record.get("img")[0] : null,
                  color: record.get("color"),
                  type: record.get("type"), //persona/managed
                  emoji: record.get("emoji"),
                  users: record.get("users") ? record.get("users")[0] : [],
                  admins: record.get("admins") ? record.get("admins")[0] : [],
                })),
            ]);
            fetchNextPage();
          },
          function done(err) {
            if (err) {
              console.error(err);
              return;
            }
          }
        );
    }
  }, [spaces]);

  useEffect(() => {
    if (
      users.length &&
      videos.length &&
      metadata.length &&
      projects.length &&
      metaDataTypes.length &&
      apps.length &&
      playlists.length &&
      spaces.length
    ) {
      setReady(true);
    }
  }, [users, videos, metadata, projects, metaDataTypes, apps, playlists]);
  // }, [metaDataTypes]);

  // const saveToLocal = (alert) => {
  //   let data = JSON.stringify({
  //     stacks: stacks,
  //   });
  //   // .replace('value:false,', 'defaultValue:false,')
  //   // .replace('value:true,', 'defaultValue:true,');
  //   localStorage.setItem("gs", data);
  //   if (alert)
  //     addToast("Saved Successfully", {
  //       appearance: "success",
  //       autoDismiss: true,
  //       autoDismissTimeout: 500,
  //     });
  // };

  const getFromLocal = () => {
    let data = localStorage.getItem("gs");
    return Boolean(data) ? JSON.parse(data) : null;
  };

  const getUserDataById = (userId) => {
    let user = users.filter((oneUser) => oneUser["id"] === userId);
    let blankUser = {
      id: "-",
      name: "-",
      title: "-",
      ava: "",
      log: [],
    };
    return user.length ? user[0] : blankUser;
  };

  const getUsersForProjects = (date, activeProjects = []) => {
    // activeUsers
    let users = [];
    console.log("data[users] = ", data["users"]);
    data["users"].forEach((oneUser) => {
      if (!activeUsers.includes(oneUser["id"])) return;
      // let checkDate = date === oneUser['log']['date'];
      let userLogForDay = oneUser["log"].filter(
        (oneLogEntry) =>
          oneLogEntry["date"] === date &&
          activeProjects.includes(oneLogEntry["project"])
      );
      let userFiltered = JSON.parse(JSON.stringify(oneUser));
      userFiltered["log"] = userLogForDay;
      if (userLogForDay.length) users.push(userFiltered);
    });
    return users;
  };

  const setNewDate = (newDate) => setActiveDate(newDate);


  const playlistRename = (newName) => {
    alert(`New Playlist Name = "${newName}"`)
  };

  const playlistDelete = (playlistId) => {
    if (window.confirm(`Are you sure you want to delete playlist "${getDataById(context, 'playlists', playlistId, 'title')}"?`)) {
      // Save it!
      console.log('Thing was saved to the database.');
    } else {
      // Do nothing!
      console.log('Thing was not saved to the database.');
    }
  };

  const context = {
    version,
    toggle,
    ready,
    user: {
      ...user,
      // email: user['email'],
    },
    state: {
      activeUsers,
      activeProjects,
      activeDate,
      activeApps,
    },
    data: {
      playlists,
      metaDataTypes,
      users,
      projects,
      videos,
      metadata,
      apps,
      spaces,
      // projects: data['projects'],
      // users: data['users'],
    },
    handles: {
      getUserDataById,
      getUsersForProjects,
      setNewDate,
      setActiveUsers,
      setActiveProjects,
      getPlaylistIdFromName,
      playlistRename,
      playlistDelete,
      setVersion,
    },
  }

  return (
    <Context.Provider
      value={{ ...context }}
    >
      {!ready && (
        <Preloader0>
          <Preloader width={120} height={120} />{" "}
        </Preloader0>
      )}
      {ready && children}
    </Context.Provider>
  );
}

const Consumer = Context.Consumer;

export { Context, Provider, Consumer };